import browserWorker from 'worker-loader!../workers/browser-worker'

export default function BBBtests() {
    this._state = 0
    console.log("Démarrage")
}

BBBtests.prototype = {
    constructor: BBBtests,
    getState: function() {
        return this._state;
    },
    browser: function() {
        this.browser_test = new browserWorker()
        this.browser_test.onmessage = function(e) {
            this.testRes = e.data
            console.log(e.data)
        }.bind(this)
        this.browser_test.postMessage('hola')
    }
}
